import styled from "styled-components";
import Column from "../../atoms/Column";
import Row from "../../atoms/Row";
import { device } from "../../../theme";

interface IContainerProps {
  column?: boolean;
}

export const Container = styled(Row)`
  align-items: center;
  justify-content: center;
  padding: 0 5%;
  gap: 20px;
  flex-direction: column;

  @media ${device.mobileL} {
    padding: 0 5%;
    gap: 20px;
    flex-direction: column;
  }

  @media ${device.tablet} {
    padding: 0 10%;
    gap: ${({ column }: IContainerProps) => (column ? "20px" : "5%")};
    flex-direction: ${({ column }: IContainerProps) =>
      column ? "column" : "row"};
  }

  @media ${device.laptop} {
    padding: 0 12%;
    gap: ${({ column }: IContainerProps) => (column ? "20px" : "10%")};
    flex-direction: ${({ column }: IContainerProps) =>
      column ? "column" : "row"};
  }

  @media ${device.laptopL} {
    padding: 0 20%;
    gap: ${({ column }: IContainerProps) => (column ? "20px" : "10%")};
    flex-direction: ${({ column }: IContainerProps) =>
      column ? "column" : "row"};
  }
`;

export const SectionHeadingContainer = styled(Column)`
  justify-content: center;
  align-items: flex-end;
`;

export const SectionDescriptionContainer = styled(Column)`
  justify-content: center;
  align-items: flex-start;
  flex: 1;
`;
